import CoreCapsule from '@usecapsule/core-sdk';
import { WebUtils } from './WebUtils.js';
export class Capsule extends CoreCapsule {
    getPlatformUtils() {
        return new WebUtils();
    }
}
